module.exports = __webpack_public_path__ + "img/07.f46c87a4.jpg";